import PropTypes from 'prop-types'
import classNames from 'classnames'

import useWindowSize from 'hooks/useWindowSize'

import CloudinaryMedia from 'components/CloudinaryMedia'
import Link from 'components/Link'

import s from './CoverHighlight.module.css'

// TODO: This is similar to <SliderCover /> so we could try and refactor both
// to combine. Just need to consider how data is passed into each component and unify.
function CoverHighlight({ cover = {}, className = '' }) {
  const windowSize = useWindowSize()
  const isDesktop = windowSize?.width >= 900
  const isMobile = windowSize?.width < 900

  const { slug, title, acfHighlightCover, acfHighlightSettings, acfBlocks } =
    cover

  if (!acfHighlightCover?.covers) return null

  const {
    videoMobile,
    videoMobileWebm,
    videoDesktop,
    videoDesktopWebm,
    imageMobile,
    imageDesktop,
  } = acfHighlightCover.covers[0]

  // TODO: Added quickly for Cloudinary replacement. Refactor when time allocated.
  // Please put WebMs first in the array.
  const videosMobile = [
    videoMobileWebm?.node?.mediaItemUrl
      ? {
          url: videoMobileWebm.node.mediaItemUrl,
          type: videoMobileWebm.node.mimeType,
          // params: 'f_auto,vc_auto,ac_none',
        }
      : undefined,
    videoMobile?.node?.mediaItemUrl
      ? {
          url: videoMobile.node.mediaItemUrl,
          type: videoMobile.node.mimeType,
          // params: 'f_auto,vc_auto,ac_none',
        }
      : undefined,
  ].filter((x) => x !== undefined)
  const videosDesktop = [
    videoDesktopWebm?.node?.mediaItemUrl
      ? {
          url: videoDesktopWebm.node.mediaItemUrl,
          type: videoDesktopWebm.node.mimeType,
          // params: 'f_auto,vc_auto,ac_none',
        }
      : undefined,
    videoDesktop?.node?.mediaItemUrl
      ? {
          url: videoDesktop.node.mediaItemUrl,
          type: videoDesktop.node.mimeType,
          // params: 'f_auto,vc_auto,ac_none',
        }
      : undefined,
  ].filter((x) => x !== undefined)
  //

  const images = [
    imageMobile?.node?.mediaItemUrl
      ? { url: imageMobile.node.mediaItemUrl, params: 'f_auto' }
      : undefined,
    imageDesktop?.node?.mediaItemUrl
      ? {
          url: imageDesktop.node.mediaItemUrl,
          params: 'f_auto',
        }
      : undefined,
  ].filter((x) => x !== undefined)

  const model = acfHighlightSettings?.models?.nodes?.[0]

  const setLink = (label, className) => {
    return acfBlocks?.contentBlocks?.length > 0 ? (
      <Link className={className} href={slug} type="Highlight">
        {label}
      </Link>
    ) : (
      label
    )
  }

  return (
    <div className={classNames(s.container, className)}>
      {(videosMobile || images) &&
        isMobile &&
        setLink(
          <CloudinaryMedia videos={videosMobile} videoLoop images={images} />
        )}
      {(videosDesktop || images) &&
        isDesktop &&
        setLink(
          <CloudinaryMedia videos={videosDesktop} videoLoop images={images} />
        )}
      <div className={s.infoWrapper}>
        <div className={s.info}>
          {model?.slug ? (
            <Link href={model.slug} type="Model">
              <h2
                className={s.title}
                dangerouslySetInnerHTML={{ __html: model.title }}
              />
            </Link>
          ) : (
            <h2
              className={s.title}
              dangerouslySetInnerHTML={{ __html: title }}
            />
          )}
          {acfHighlightCover?.shortDescription &&
            setLink(
              <>
                <span
                  className={s.tag}
                  dangerouslySetInnerHTML={{
                    __html: acfHighlightCover?.shortDescription,
                  }}
                />
              </>,
              s.tags
            )}
          {acfBlocks?.contentBlocks?.length > 0 &&
            setLink('View Article', s.link)}
        </div>
      </div>
    </div>
  )
}

CoverHighlight.propTypes = {
  cover: PropTypes.object,
  className: PropTypes.string,
}

export default CoverHighlight
